import React from "react"
import { Table as BSTable } from "react-bootstrap"

const Table = ({ 
  responsive,
  className,
  children,
  noHover,
  ...rest
}) => {
  return (
    <BSTable 
      {...rest}
      bordered 
      hover={!noHover}
      responsive={responsive}
      className={`bg-white border-1 shadow-sm ${className}`}
    >
      {children}
    </BSTable>
  )
}

export default Table